import { BucketDetails } from "./BucketDetails";

export default BucketDetails;
